module.exports = __webpack_public_path__ + "img/company-select-bg.c22f71ca.png";